import { render, staticRenderFns } from "./EventsPreview.vue?vue&type=template&id=665d9afc&scoped=true"
import script from "./EventsPreview.vue?vue&type=script&lang=js"
export * from "./EventsPreview.vue?vue&type=script&lang=js"
import style0 from "./EventsPreview.vue?vue&type=style&index=0&id=665d9afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d9afc",
  null
  
)

export default component.exports